
    import I18n from 'i18nObj';
    
      import 'translations/conferences.edit_conference_form';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('conferences.edit_conference_form');
  